import { useGetAppointmentDateQuery } from "services/tickets";

export const useAppointmentDate = (param: string) => {
  const queryResult = useGetAppointmentDateQuery(param, {
    refetchOnMountOrArgChange: true, // Automatically refetch on mount or when args change
  });

  return queryResult;
};